import { getData, waitForData } from '@ifit/native-webview-interface';
import { IParams } from '../models/dictionary';

export const storageKey = 'put-a-ring-on-it/positive-engagement';

let getDataFunc: typeof getData = getData;
let waitForDataFunc: typeof waitForData = waitForData;

export function setStorageFunctions(
  newGetData: typeof getData,
  newWaitForData: typeof waitForData,
): void {
  getDataFunc = newGetData || getData;
  waitForDataFunc = newWaitForData || waitForData;
}

export async function read(): Promise<IParams> {
  const data = await waitForDataFunc([`store://get/${storageKey}`]);
  if (!data[storageKey]) {
    return {};
  }
  const decoded = decodeURIComponent(data[storageKey]);
  return JSON.parse(decoded);
}

export function write(params: IParams): void {
  getDataFunc([
    `store://put/${storageKey}?${encodeURIComponent(JSON.stringify(params))}`,
  ]);
}
